import React from "react";
import "./SolutionCards.css";
import { Link } from 'react-router-dom';

const SolutionCardsData = [
    {
        image: "/Images/solution-icons/Retrofit-Process-&-Mechanical-Systems.png",
        heading: "Retrofit Process & Mechanical Systems",
        desc: "Boltcrew Engineering audits and modernizes legacy mechanical systems through custom fabrication and turnkey upgrades for maximum efficiency.",
        targetId: "Retrofit-Process-&-Mechanical-Systems"
    },
    {
        image: "/Images/solution-icons/Preventive-Maintenance-&-Service-Contracts.png",
        heading: "Preventive Maintenance & Service Contracts",
        desc: "Boltcrew Engineering provides proactive inspections, monitoring, and calibration to prevent downtime and reduce operational costs.",
        targetId: "Preventive-Maintenance-&-Service-Contracts"
    },
    {
        image: "/Images/solution-icons/Spare-Part-Management-&-Supply.png",
        heading: "Spare Part Management & Supply",
        desc: "Boltcrew Engineering optimizes inventory and secures high-quality spare parts through global sourcing and rapid delivery.",
        targetId: "Spare-Part-Management-&-Supply"
    },
    {
        image: "/Images/solution-icons/Electrical-&-Control-System.png",
        heading: "Electrical & Control System",
        desc: "Boltcrew Engineering provides power distribution, automation, and system integration to ensure safe, intelligent, and precise operations.",
        targetId: "Electrical-&-Control-System"
    }
];

const SolutionCard = ({ item }) => {
    const cardRef = React.useRef(null);
    const [style, setStyle] = React.useState({});

    const handleMouseMove = (e) => {
        if (window.innerWidth <= 1200) return;
        if (!cardRef.current) return;

        const { left, top, width, height } = cardRef.current.getBoundingClientRect();
        const x = (e.clientX - left - width / 2) / 25; 
        const y = (e.clientY - top - height / 2) / 25;

        const rotateX = -y * 2; 
        const rotateY = x * 2;

        setStyle({
            transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`,
            transition: 'transform 0.1s ease-out'
        });
    };

    const handleMouseLeave = () => {
        setStyle({
            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
            transition: 'transform 0.5s ease-out'
        });
    };

    return (
        <div
            className="solution__cards__s1"
            ref={cardRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={style}
        >
            <img src={item.image} alt={item.heading} className="solution__cards__image" />
            <h3 className="solution__cards__heading">{item.heading}</h3>
            <p className="solution__cards__desc">{item.desc}</p>
            <Link to={`/solutions#${item.targetId}`} className="solution__read__more">
                <button>Read More</button>
            </Link>
        </div>
    );
};

const SolutionCards = () => {
    return (
        <div className="solution__cards">
            {SolutionCardsData.map((item, index) => (
                <SolutionCard key={index} item={item} />
            ))}
        </div>
    );
}

export default SolutionCards;